// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetOrganisationsRequestModel from '../../model/get-organisations-request-model';
import GetOrganisationsRequestDTO from '../dto/get-organisations-request-dto';
import dtoSchema from '../schemas/get-organisations-request-schema';

export default abstract class GetOrganisationsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetOrganisationsRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.eventIdentifier = data.eventIdentifier;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {uuid}
  */
  eventIdentifier?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetOrganisationsRequestDTO>): GetOrganisationsRequestModel;
  static toModel(dto: DeepPartial<GetOrganisationsRequestDTO> | undefined | null): GetOrganisationsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetOrganisationsRequestDTO> | undefined | null): GetOrganisationsRequestModel | undefined {
    return dto ? new GetOrganisationsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetOrganisationsRequestModel> | GetOrganisationsRequestModel): GetOrganisationsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      eventIdentifier: unwrapped.eventIdentifier,
      searchCriteria: unwrapped.searchCriteria,
    } as GetOrganisationsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetOrganisationsRequestModel, can not map to GetOrganisationsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
